import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";

import { CalendarToolbar } from "../../components/CalendarToolbar";
import IntlMessages from "../../helpers/IntlMessages";
import data from "../../data/events";

import { getDirection } from "../../helpers/Utils";

import "react-big-calendar/lib/css/react-big-calendar.css"; // make sure CSS import is there

const localizer = momentLocalizer(moment);

const Calendar = () => {
  return (
    <Card>
      <CardBody>
        <CardTitle>
          <IntlMessages id="dashboards.calendar" />
        </CardTitle>
        <BigCalendar
          localizer={localizer}
          style={{ minHeight: "500px" }}
          events={data}
          rtl={getDirection().isRtl}
          views={["month"]}
          components={{
            toolbar: CalendarToolbar,
          }}
        />
      </CardBody>
    </Card>
  );
};

export default Calendar;
